<div class="videos-container">

  <div class="header">
    {{ 'profile.videos' | translate }}
  </div>

  <div class="row g-0">
    @for (video of videos; track video) {
      <div class="col-12 col-md-6 col-xl-4 mt-4">
        <div class="video-container">
          <libero-video-preview [videoPreview]="video"></libero-video-preview>
        </div>
        <div class="video-name">
          {{ video.name }}
        </div>
        <hr class="mobile-divider">
      </div>
    }
  </div>
</div>